import type { TrackConfiguration, TrackType } from "../../../types.ts";

export const updateTrackConfiguration = (
  trackConfiguration: TrackConfiguration,
  selectedGroupIds: string[],
  selectedTracks: string[],
  selection: string[],
) => {
  const newTrackConfiguration = new Map(trackConfiguration);
  const added = selection.filter((trackType) => !selectedTracks.includes(trackType));
  const removed = selectedTracks.filter((trackType) => !selection.includes(trackType));
  for (const groupId of selectedGroupIds) {
    newTrackConfiguration.set(groupId, {
      defaultTypes: trackConfiguration
        .get(groupId)!
        .defaultTypes.concat(added as TrackType[])
        .filter((trackType) => !removed.includes(trackType)),
      nuFeatureTypes: trackConfiguration.get(groupId)!.nuFeatureTypes,
    });
  }
  return newTrackConfiguration;
};

export const updateTrackConfigurationNu = (
  availableTrackConfiguration: TrackConfiguration,
  trackConfiguration: TrackConfiguration,
  selectedGroupIds: string[],
  nuFeatureSelection: string[],
) => {
  const newTrackConfiguration = new Map(trackConfiguration);
  const availableNuFeatures = selectedGroupIds.flatMap(
    (groupId) => availableTrackConfiguration.get(groupId)!.nuFeatureTypes,
  );
  const selectedNuFeatures = nuFeatureSelection.map(
    (featureId) => availableNuFeatures.find((feature) => feature.id.toString() === featureId)!,
  );

  for (const groupId of selectedGroupIds) {
    newTrackConfiguration.set(groupId, {
      defaultTypes: newTrackConfiguration.get(groupId)!.defaultTypes,
      nuFeatureTypes: selectedNuFeatures.filter((featureType) =>
        availableTrackConfiguration.get(groupId)!.nuFeatureTypes.some((track) => track.id === featureType.id),
      ),
    });
  }
  return newTrackConfiguration;
};
